module.exports = __webpack_public_path__ + "img/BW.58f0d000.svg";